module.exports = __webpack_public_path__ + "static/media/Fallecimiento3.6006460c.svg";